// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Qeq_Oxy-0mHVm3mQskfK-{position:absolute}", "",{"version":3,"sources":["webpack://src/resources/styles/game/player.scss"],"names":[],"mappings":"AAGA,uBACI,iBAAA","sourcesContent":["@import '../commons/variables';\n@import '../commons/placeholders';\n\n.container {\n    position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "Qeq_Oxy-0mHVm3mQskfK-"
};
export default ___CSS_LOADER_EXPORT___;
